import React, { useState } from 'react';
import { createCheckoutSession } from '../services/subscriptionService';
import PricingTiers from './PricingTiers';

const UpgradePrompt = ({ isOpen, onClose, currentPlan = 'free' }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleUpgrade = async (planType) => {
        if (planType === currentPlan) {
            return;
        }

        // Show disabled message for paid plans
        if (planType === 'basic' || planType === 'unlimited') {
            setError('Subscription purchases are temporarily disabled while we set up our payment system. Please check back soon!');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const { url } = await createCheckoutSession(planType);
            window.location.href = url;
        } catch (err) {
            console.error('Failed to create checkout session:', err);
            setError(err.message || 'Failed to start checkout process');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white max-w-2xl w-full p-6">
                {/* Header */}
                <div className="flex justify-between items-start mb-6">
                    <div>
                        <h2 className="font-sans text-3xl font-medium text-[#1b263b] mb-2">
                            Upgrade Your Plan
                        </h2>
                        <p className="font-sans text-base leading-relaxed text-neutral-900">
                            You've reached your recipe limit. Choose a plan to continue creating recipes.
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-neutral-900 hover:opacity-60 transition-opacity duration-120 font-mono text-lg border-none bg-transparent p-0 m-0"
                    >
                        ×
                    </button>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="mb-6 p-4 bg-red-50 border border-red-200 text-red-800">
                        {error}
                    </div>
                )}

                {/* Pricing Tiers */}
                <PricingTiers 
                    currentPlan={currentPlan}
                    onSelectPlan={handleUpgrade}
                    loading={loading}
                    showCurrentPlan={true}
                />

                {/* Footer */}
                <div className="mt-6 pt-6 border-t border-neutral-200">
                    <p className="text-sm text-neutral-600 text-center">
                        All plans include secure payment processing via Stripe. 
                        Cancel anytime from your account settings.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UpgradePrompt;
